import React from 'react'
import PropTypes from 'prop-types'

import { CurvedArrow } from '../icons'

/**
ClassNameArr structure
[icon, text]
 */

function RateDisclaimer({ classNameArr, height, width, primary, noIcon, alt, customMessage }) {
  return (
    <>
      {!noIcon && (
        <CurvedArrow
          className={classNameArr[0]}
          fill={primary ? '#fff' : '#4F5E66'}
          stroke={primary ? '#fff' : '#4F5E66'}
          height={height}
          width={width}
        />
      )}

      <p className={classNameArr[1]}>
        {customMessage ||
          (alt ? (
            "Checking your offer won't impact your credit score"
          ) : (
            <>
              Checking your eligibility&nbsp;<strong>does not</strong> affect your credit score.
            </>
          ))}
      </p>
    </>
  )
}

RateDisclaimer.defaultProps = {
  height: 34,
  width: 45,
  primary: false,
  noIcon: false,
  alt: false,
  customMessage: null
}

RateDisclaimer.propTypes = {
  classNameArr: PropTypes.array.isRequired,
  height: PropTypes.number,
  width: PropTypes.number,
  primary: PropTypes.bool,
  noIcon: PropTypes.bool,
  alt: PropTypes.bool,
  customMessage: PropTypes.string
}

export default RateDisclaimer
